import { render, staticRenderFns } from "./index.vue?vue&type=template&id=137dc771"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('137dc771')) {
      api.createRecord('137dc771', component.options)
    } else {
      api.reload('137dc771', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=137dc771", function () {
      api.rerender('137dc771', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/stat/index.vue"
export default component.exports